import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../Sidebar";
import TopBar from "../TopBar";
import { useLocation } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import SprzedazKPI from "../dashboard/SprzedazKPI";
import KontrahentKPI from "../dashboard/KontrahentKPI";
import ZakupyKPI from "../dashboard/ZakupyKPI";
import AlertsAI from "../dashboard/AlertsAI";
import ChartsPanel from "../dashboard/ChartsPanel";
import loadingGif from "../../assets/loading.gif";
import SuggestionsInfo from "../dashboard/SuggestionsInfo";
import BasicDemoConsentModal from "./BasicDemoConsentModal";
import "./DashboardGrid.css";

// IDB helpers
import { getDB, dbPut } from "../../db";

const formatPath = (path) => {
  const customNames = {
    "sprzedaz/dashboard": { name: "Dashboard", icon: <FaHome /> },
  };
  const cleanPath = path.replace(/^\//, "");
  return (
    customNames[cleanPath] || {
      name: cleanPath.replace("/", " / "),
      icon: null,
    }
  );
};

const CardShell = ({ children }) => (
  <div
    style={{
      width: "100%",
      border: "1px solid #e5e7eb",
      borderRadius: "12px",
      padding: "22px",
      backgroundColor: "#ffffff",
      boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
    }}
  >
    {children}
  </div>
);

const SprzedazComponent = () => {
  const locationData = useLocation();
  const { name, icon } = formatPath(locationData.pathname);

  const [salesData, setSalesData] = useState([]);
  const [zakupyData, setZakupyData] = useState([]);

  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [loadingComponent, setLoadingComponent] = useState("Inicjalizacja...");

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const token = localStorage.getItem("token");
        const now = Date.now();

        setLoading(true);
        setProgress(5);
        setLoadingComponent("Nawiązywanie połączenia...");

        await getDB();

        setLoadingComponent("Pobieranie danych sprzedaży...");
        const spr = await axios.get(
          "https://server229256.nazwa.pl/api/sprzedaz",
          { headers: { Authorization: token } }
        );
        const sales = spr.data || [];
        setSalesData(sales);
        await dbPut("sales", "allSales", { data: sales, timestamp: now });
        setProgress(50);

        setLoadingComponent("Pobieranie danych zakupów...");
        const zak = await axios.get(
          "https://server229256.nazwa.pl/api/zakupy",
          { headers: { Authorization: token } }
        );
        const purchases = zak.data || [];
        setZakupyData(purchases);
        await dbPut("zakupy", "allZakupy", {
          data: purchases,
          timestamp: now,
        });
        setProgress(100);

        await new Promise((resolve) => setTimeout(resolve, 200));
      } catch (error) {
        console.error("Fetch error:", error);
        setLoadingComponent("Błąd podczas pobierania danych.");
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, []);

  if (loading) {
    return (
      <>
        <BasicDemoConsentModal />

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            backgroundColor: "#f5f5f5",
            flexDirection: "column",
            padding: "0 16px",
            textAlign: "center",
          }}
        >
          <img
            src={loadingGif}
            alt="Loading..."
            style={{ width: 100, marginBottom: 20 }}
          />
          <h1 style={{ color: "#87CEEB", margin: 0 }}>
            Ładowanie danych...
          </h1>
          <p style={{ fontSize: "1.05rem", color: "#555", marginTop: 10 }}>
            Proszę czekać, trwa przygotowywanie dashboardu.
          </p>

          <div
            style={{
              width: 320,
              maxWidth: "90vw",
              height: 20,
              backgroundColor: "#e0e0e0",
              borderRadius: 10,
              overflow: "hidden",
              marginTop: 18,
              boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            <div
              style={{
                width: `${progress}%`,
                height: "100%",
                backgroundColor: "#87CEEB",
                transition: "width 0.3s ease",
              }}
            />
          </div>
          <p style={{ marginTop: 10, color: "#555" }}>
            {progress}% — {loadingComponent}
          </p>
        </div>
      </>
    );
  }

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <BasicDemoConsentModal />

      <div
        style={{
          position: "sticky",
          top: 0,
          height: "100vh",
          flexShrink: 0,
          overflow: "hidden",
        }}
      >
        <Sidebar />
      </div>

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        <TopBar />

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 20px",
            fontSize: "1.2rem",
            fontWeight: "bold",
            color: "#87CEEB",
            marginBottom: "8px",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            flexShrink: 0,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {icon} {name}
          </div>
          <div style={{ display: "flex", gap: "10px" }} />
        </div>

        <div
          className="dashboard-grid"
          style={{
            flex: 1,
            overflowY: "auto",
            backgroundColor: "#f5f5f5",
            padding: 20,
            minHeight: 0,
          }}
        >
          <div className="card-span-6">
            <CardShell>
              <AlertsAI
                salesData={salesData}
                purchasesData={zakupyData}
              />
            </CardShell>
          </div>

          <div className="card-span-6">
            <CardShell>
              <SuggestionsInfo
                salesData={salesData}
                purchasesData={zakupyData}
              />
            </CardShell>
          </div>

          <div className="card-span-12">
            <CardShell>
              <SprzedazKPI
                salesData={salesData}
                purchasesData={zakupyData}
              />
            </CardShell>
          </div>

          <div className="card-span-12">
            <CardShell>
              <ZakupyKPI
                purchasesData={zakupyData}
                salesData={salesData}
              />
            </CardShell>
          </div>

          <div className="card-span-12">
            <CardShell>
              <ChartsPanel
                salesData={salesData}
                purchasesData={zakupyData}
              />
            </CardShell>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SprzedazComponent;
